import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { BehaviorSubject, Subject } from 'rxjs';
import { Endpoints } from "../../shared/config/endpoints";
import { GeneralService } from "../general.service";
import DateUtils from 'src/app/utils/date';
import { OrgModel} from "./../../store/storeModels/user.model";
// import { SubscriptionModel } from '../models/subscription.model';
import { Observable, of } from "rxjs";
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: "root",
})
export class LeadService {
  //
  private _host: string;
  private server: string;
  private _baseUrl: string;
  private _baseUrls: string;
  private _filterUrl: string;
  private _testUrl: string;
  private _testPort: 3200;
  private _local: string;
  private dateHandler = new DateUtils;
  private teamId;
  private reloadTrigger = new Subject<void>();
  private reloadTrigger2 = new Subject<void>();
  private eventSubject = new BehaviorSubject<any>(null);
  canBeConvertedToClient: boolean = false;
  hasBeenConvertedToClient: boolean = false;
  
  /** SUBJECT */
  reload$ = this.reloadTrigger.asObservable();
  reload2$ = this.reloadTrigger2.asObservable();

  /** BEHAVIOR SUBJECT */
  filter_query: any = new BehaviorSubject<any>('');
  filter_state: any = new BehaviorSubject<boolean>(false);
  lead_info_from_server: any = new BehaviorSubject<any>({});
  local_lead_info: any = new BehaviorSubject<any>({});
  new_lead: any = new BehaviorSubject<any>({});
  salespersons: any = new BehaviorSubject<any>([]);
  teams: any = new BehaviorSubject<any>([]);
  selected_lead_to_assign: any = new BehaviorSubject<any>({});
  event$ = this.eventSubject.asObservable();
  triggerEnrichment$ = new Subject<void>();
  private org: OrgModel;
  //
  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private genServ: GeneralService,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.org = info.organization;
      if (Object.keys(info).length) {
        this.teamId = info.user.teamID;
      }
    })
    this._host = `${this.endpoints.fourFourSixEndpoint}`;
    this._local = `http://localhost:3200`;
    this._baseUrl = `${this._host}/leads`;
    this._baseUrls = `${this.server}/leads`;
    this._filterUrl = `${this._baseUrl}/filter`;
    this._testUrl = `${this.endpoints.clientsAndSalesServiceLocalUrl}/leads`;
  }

    sendEvent(event: any) {
    this.eventSubject.next(event);
  }

  private paginateurl(url, page = 0, population = 20) {
    return `${url}?page=${page}&population=${population}`;
  }

  fetchLeads(params?) {
    try {
      // return this.http.get(`${this._baseUrl}/filter`, { params })
      return this.http.get(`${this._baseUrl}/filter`, { params })
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  triggerReloaad() {
    this.reloadTrigger.next()
  }

  triggerReloaad2() {
    this.reloadTrigger2.next()
  }

  fetchLead(id) {
    try {
      return this.http.get(`${this._baseUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  filterLead(query) {
    try {
      return this.http.get(`${this._filterUrl}?${query}`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  createLead(payload) {
    try {
      return this.http
        .post(this._baseUrl, { ...payload, teamId: this.teamId })
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  captureLead(payload) {
    try {
      return this.http
        .post(this._baseUrl + '/new', {
          ...payload,
          teamId: this.teamId,
        }).pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  createContact(payload) {
    try {
      const processedInfo = this.processLeadInfo({ ...payload });
      delete processedInfo.id;
      return this.http
        .post(`${this._host}/contacts`, processedInfo)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  createCompany(payload) {
    try {

      const processedInfo = this.processLeadInfo({ ...payload });
      delete processedInfo.id;

      return this.http
        .post(`${this._host}/companies`, processedInfo)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  updateLead(payload) {
    try {
      const processedInfo = this.processLeadInfo({ ...payload });
      this.genServ.httpStatus.next('formDataType');
      return this.http
        .put(this._baseUrl, processedInfo)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  updateMultipleLeads(options, data) {
    return this.http.put(`${this._baseUrl}/bulk`, { options, data });
  }

  deleteLead(id) {
    try {
      this.genServ.httpStatus.next('formDataType');
      return this.http
        .delete(`${this._baseUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }


  /** */
  getLeadInfo() {
    return this.local_lead_info.value;
  }

 saveCalendlyWebhook(webhookKey: string) {
    if (!webhookKey) {
      console.error("webhookKey is required!")
      return of(null);
    }
    return this.http.post(`${this._host}/calendly-webhook/save-key/${this.org.id}`, { webhookKey });
  }

  saveCalendlyAccessToken(accessToken: string) {
    if(!accessToken) {
      console.error('Access token is required!');
      return of(null);
    }
    return this.http.post(`${this._host}/calendly-webhook/save-access-token/${this.org.id}`, {accessToken});
  }

  getCalendlyAccessToken() {
    return this.http.get<{success: boolean; data: {accessToken: string}}>(`${this._host}/calendly-webhook/get-access-token/${this.org.id}`)
  }

  registerCalendlyWebhook() {
    return this.http.post<{ success: boolean; message: string; data?: any }>(
      `${this._host}/calendly-webhook/register-webhook/${this.org.id}`,
      {}
    ).pipe(catchError(this.handleError));
  }
  

  // getCalendlyWebhook() {
  //   return this.http.get<{ success: boolean; payload: { webhookKey: string } }>(`http://localhost:3200/calendly-webhook/get-key/${this.org.id}`)
  //     .pipe(catchError(this.handleError));    
  // }
  saveApolloApiKey(apiKey: string) {
    if (!apiKey) {
      console.error("API Key is required!");
      return of(null);
    }
    return this.http.post(`${this._host}/lead-enrichment/save-api-key/${this.org.id}`, { apiKey })

  }
  
  getApolloApiKey() {
    return this.http.get<{ success: boolean; payload: { apiKey: string } }>(`${this._host}/lead-enrichment/get-api-key/${this.org.id}`)
  }

  getEnrichment(payload) {
        const body = {
      ...payload,
      orgId: this.org.id,
    };
    try {
      return this.http.post(`${this._host}/lead-enrichment/enrich-lead`, body)
      .pipe(
        catchError(this.handleError)
      )
    } catch (e) {
        alert(e)
      }
  }

  getCompanyEnrichment(payload) {
    const body = {
      ...payload,
      orgId: this.org.id,
    };
    console.log('Request payload:', payload);
    return this.http.post(`${this._host}/lead-enrichment/enrich-company-lead`, body).pipe(
      catchError(this.handleError)
    );
  }

  processLeadInfo(payload) {
    const processed_info = {
      ...payload,
      id: payload.id || this.lead_info_from_server.value.id,
      // staffStrength: payload['staffStrength'] && payload['staffStrength'].length > 0 ? payload['staffStrength'] : null,
      staffStrength: payload.staffStrength? payload.staffStrength: null,
      yearOfEstablishment: payload.yearOfEstablishment? payload.yearOfEstablishment: null,
      yearOfIncorporation: payload.yearOfIncorporation? payload.yearOfIncorporation: null,
    }

    return processed_info;
  }
  checkIfLeadHasBeenConvertedToClient() {
    return this.local_lead_info.value.clientId;
  }

  markLeadAsConvertible(isDone): void {
    this.canBeConvertedToClient = isDone;
  }

  canLeadBeConvertedToDeal(): boolean {
    return (this.local_lead_info.clientType && this.local_lead_info.clientType.length > 1);
  }

  /**
   * 
   */
  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  }
}
